import { BufferRenderer } from "./BufferRenderer"


export class BoosterRenderer extends BufferRenderer {

    movePointer(x: number, y: number) { }

    fill(x: number, y: number) { }
}